import React, { useEffect, useState } from 'react';
import Loader from '../../common/Loader';
import { useFetchAutocompleteData } from '../../data/fetchAutocompleteData';
import { filterSearchResults } from '../../data/utils/filterSearchResults';
import MatchLinkSearchBar from '../navigation/MatchLinkSearchBar';
import { PrematchContext } from '../Prematch';

export default function SearchOverlay(props) {
    const prematchContext = React.useContext(PrematchContext);
    const [data, setData] = useState(prematchContext.cache.autocomplete);

    const dataNotCahed = data == null;
    const [state] = useFetchAutocompleteData(false, dataNotCahed);

    useEffect(() => {
        if (!state.isLoading && !state.isErrore) {
            prematchContext.cache.autocomplete = state.data;
            setData(state.data);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [state]);
    
    let sports = [];
    if (data != null) {
        const results = filterSearchResults(data, props.search, 'MATCH', match => match.desc);

        const sportById = {};
        results.forEach(function(match) {
            if (sportById[match.sportRef] == null) {
                const sport = {
                    id: match.sportRef,
                    desc: match.sportDesc,
                    tournaments: [],
                    tournamentById: {},
                };
                sports.push(sport);
                sportById[match.sportRef] = sport;
            }
            const sport = sportById[match.sportRef];
            if (sport.tournamentById[match.tournamentRef] == null) {
                const tournament = {
                    id: match.tournamentRef,
                    desc: match.tournamentDesc,
                    events: [],
                };
                sport.tournaments.push(tournament);
                sport.tournamentById[match.tournamentRef] = tournament;
            }
            const tournament = sport.tournamentById[match.tournamentRef];
            tournament.events.push(match);
        });
        
        // If prematch, sort sports by ranking
        try {
            sports.sort((a, b) => {
                const rankingA = prematchContext.data.sportById[a.id].ranking;
                const rankingB = prematchContext.data.sportById[b.id].ranking;
                return rankingA - rankingB;
            });
        } catch(e) {
            console.error(e);
        }
    }

    return (
        <div id="nav-search-events" className="search-overlay">
            <div className="overlay-content">
                {data == null ?
                    <Loader error={state.isError} />
                    :
                    <>
                        {sports.map(sport =>
                            <React.Fragment key={sport.id}>
                                <div className="sport-heading text-medium">{sport.desc}</div>
                                {sport.tournaments.map(tournament =>
                                    <React.Fragment key={tournament.id}>
                                        <div className="manif-heading text-small">{tournament.desc}</div>
                                        {tournament.events.map(match => {
                                            function handleClick() {
                                                props.toggleSearch();
                                                prematchContext.openMatchFromSearch(match);
                                            }
                                            return (
                                                <MatchLinkSearchBar key={match.uniqueId} {...match} openMatch={handleClick} />
                                            );
                                        })}
                                    </React.Fragment>
                                )}
                            </React.Fragment>
                        )}
                    </>
                }
            </div>
        </div>
    );
}
